import * as React from "react";
import { DayPicker } from "react-day-picker";
import { ptBR } from "react-day-picker/locale";
import { cn } from "@/lib/utils";

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

export function Calendar({ className, classNames, ...props }: CalendarProps) {
  return (
    <DayPicker
      locale={ptBR}
      className={cn("select-none", className)}
      classNames={{
        root: "rdp",
        months: "flex flex-col",
        month: "space-y-2",
        month_caption: "relative flex h-9 items-center justify-center",
        caption_label: "text-text-primary text-sm font-medium capitalize",
        nav: "absolute inset-x-0 top-0 flex items-center justify-between px-1",
        button_previous:
          "hover:bg-bg-muted inline-flex h-7 w-7 items-center justify-center rounded-md",
        button_next: "hover:bg-bg-muted inline-flex h-7 w-7 items-center justify-center rounded-md",
        chevron: "fill-text-secondary h-4 w-4",
        month_grid: "w-full border-collapse",
        weekdays: "",
        weekday: "text-text-tertiary h-8 w-9 text-[11px] font-normal",
        week: "",
        day: "p-0 text-center",
        day_button:
          "hover:bg-bg-muted inline-flex h-9 w-9 items-center justify-center rounded-md text-[13px]",
        selected: "bg-brand-500 hover:bg-brand-500 rounded-md text-white",
        today: "text-brand-600 font-semibold",
        outside: "text-text-tertiary opacity-50",
        disabled: "pointer-events-none opacity-40",
        ...classNames,
      }}
      {...props}
    />
  );
}
